import { ResultSet } from '@cubejs-client/core';
import { Union } from 'ts-toolbelt';

export const getPrimaryValue = (resultSet: Union.Nullable<ResultSet>, field: string): number | null => {
  return Number(resultSet?.rawData()[0]?.[field]) || null;
};
